import { api } from '../../core/network/api';

/**
 * Weapon charms (E6, `design/economy/economy-rebuild.md` §4.4) — `CharmsController`'s three
 * routes. Equip is global (one charm per account, not per loadout slot) — see the header of
 * `shared/src/charms.ts` for why a per-slot value would encode nothing a global one does not
 * already say.
 */
export interface CharmEntry {
  id: number;
  name: string;
  description: string;
  /** 0xrrggbb — numeric, unlike the weapon-skin catalogue's pre-formatted `#rrggbb`; the
   * server never touched CSS for this one, so it is formatted here. */
  tint: number;
  /** Optional emissive lift; absent on most of the Credits-tier charms. */
  glow?: number;
  priceCoins: number;
  currency: 'SOFT' | 'PREMIUM';
  owned: boolean;
  equipped: boolean;
  affordable: boolean;
}

export interface CharmCatalogueView {
  equippedCharm: number;
  charms: CharmEntry[];
}

/** `GET /charms`. */
export const fetchCharmsCatalogue = () => api.get<CharmCatalogueView>('/charms');

/** `POST /charms/purchase`. */
export const purchaseCharm = (charm: number) => api.post<{ equippedCharm: number }>('/charms/purchase', { charm });

/** `POST /charms/equip` — `charm: 0` (`NO_CHARM`) takes the charm off; always a legal value. */
export const equipCharm = (charm: number) => api.post<{ equippedCharm: number }>('/charms/equip', { charm });
